<template>
  <div v-if="payInfo">
    <!-- <div v-if="isSeparate" class="layer paymentLayer">
      <div class="inner">
        <p class="layerTitle">{{ locale.start_payment }}</p>
        <div class="btns">
          <button type="button" class="btn btnFull" @click.stop="paySubmit">{{ locale.do_payment }}</button>
        </div>
      </div>
    </div> -->
    <div v-show="payInfo" class="layer">
      <button
        type="button"
        class="btnClose"
        @click.stop="closePayment"></button>
      <div class="inner">
        <div id="payment-method" class="w-100"></div>
        <div id="agreement" class="w-100"></div>
        <div class="btn-wrapper w-100">
          <button
            id="payment-request-button"
            class="btn btnRound btnFull">
            {{ locale.do_payment }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadTossPayments, ANONYMOUS } from "@tosspayments/tosspayments-sdk"

export default {
  name: 'TossPayment',
  props: [
    'locale',
    'order'
  ],
  computed: {
    getPayInfo: {
      get () {
        return this.$store.getters['payment/getPaymentInfo']
      },
      set (data) {
        this.payInfo = this._.cloneDeep(data)
      }
    },
    orderName () {
      const order = this.order && this.order.payload
      return order && order[0]
    },
    productName () {
      const goods = this.order && this.order.payload
      const cnt = goods.length - 1
      const mainGoods = goods[0]
      const title = mainGoods.submitId.includes('system_amenity')
        ? this.locale.amenity
        : mainGoods.title
      const message = this.locale.order_product_count.replace('{var}', cnt) // 외 {var}건
      return cnt > 0 ? title + message : title
    },
    amount () {
      const price = this.order && this.order.price
      const currency = this.$store.getters['common/getSetting'].currency
      return {
        currency: (currency || 'KRW').toUpperCase(),
        value: price.total
      }
    }
  },
  mounted () {
    this.isSeparate = this.$route.name === 'separatePayment'
    if (this.getPayInfo) {
      this.payInfo = this._.cloneDeep(this.getPayInfo)
      this.init()
      // 알림톡 등으로부터 접근한 기본루트
      if (!this.isSeparate) {
        setTimeout(() => {
          // this.paySubmit()
        }, 100)
      } else {
        // QR코드로부터 접근한 독립 결제루트
      }
    }
  },
  data () {
    return {
      payInfo: null,
      isSeparate: false,
      isOrder: false,
      clientKey: 'test_gck_docs_Ovk5rk1EwkEbP0W43n07xlzm',
      testKey: 'test_sk_E92LAa5PVb9lAbxwoqpP37YmpXyJ',
      // amount: {
      //   currency: "KRW",
      //   value: 50000
      // }
    }
  },
  methods: {
    async init () {
      const clientKey = this.clientKey
      const amount = this.amount
      const tossPayments = await loadTossPayments(clientKey)
      const widgets = tossPayments.widgets({
        customerKey: ANONYMOUS
      })
      /**
       * 위젯의 결제금액을 결제하려는 금액으로 초기화하세요.
       * renderPaymentMethods, renderAgreement, requestPayment 보다 반드시 선행되어야 합니다.
       * @docs https://docs.tosspayments.com/sdk/v2/js#widgetssetamount
       */
      await widgets.setAmount(amount)

      await Promise.all([
        /**
         * 결제창을 렌더링합니다.
         * @docs https://docs.tosspayments.com/sdk/v2/js#widgetsrenderpaymentmethods
         */
        widgets.renderPaymentMethods({
          selector: "#payment-method",
          // 렌더링하고 싶은 결제 UI의 variantKey
          // 결제 수단 및 스타일이 다른 멀티 UI를 직접 만들고 싶다면 계약이 필요해요.
          // @docs https://docs.tosspayments.com/guides/v2/payment-widget/admin#새로운-결제-ui-추가하기
          variantKey: "DEFAULT",
        }),
        /**
         * 약관을 렌더링합니다.
         * @docs https://docs.tosspayments.com/reference/widget-sdk#renderagreement선택자-옵션
         */
        widgets.renderAgreement({ selector: "#agreement", variantKey: "AGREEMENT" }),
      ])

      const paymentRequestButton = document.getElementById('payment-request-button')

      const generateRandomString = () => window.btoa(Math.random()).slice(0, 20)
      paymentRequestButton.addEventListener('click', async () => {
        try {
          /**
           * 결제 요청
           * 결제를 요청하기 전에 orderId, amount를 서버에 저장하세요.
           * 결제 과정에서 악의적으로 결제 금액이 바뀌는 것을 확인하는 용도입니다.
           * @docs https://docs.tosspayments.com/sdk/v2/js#widgetsrequestpayment
           */
          await widgets.requestPayment({
            orderId: generateRandomString(),
            orderName: 'iSTAY Commerce',
            successUrl: "https://localhost:8081/?site=aa7&space=001&public=true#/ko/complete",
            failUrl: "https://localhost:8081/?site=aa7&space=001&public=true#/ko/complete",
            customerEmail: "customer123@gmail.com",
            customerName: "김토스",
            customerMobilePhone: "01012341234",
          })
        } catch (err) {
          // TODO: 에러 처리
        }
      })
    },
    closePayment (e) {
      if (window.confirm(this.locale.confirm_cancel_payment)) {
        e.preventDefault()
        if (this.isSeparate) {
          window.close()
        } else {
          this.$emit('close')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .btn-wrapper {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
  }
}
</style>
